module.exports = __webpack_public_path__ + "img/icon_instagram_link.c9aa4331.svg";